var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNizroWordmarkReversed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -3 906 206",
    width: 1812,
    height: 412,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "NIZRO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F7F8FA",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0L49,0L130,133.88L130,0L170,0L170,136.77L119.09,196.84L40,66.12L40,200L0,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,46.11L256,200L216,200L216,93.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,0L468,0L468,36L359.53,164L474,164L474,200L302,200L302,164L410.47,36L308,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520,0H604A76,58 0 0 1 634.28,111.2L688,200H636.57L585.75,116H560V200H520ZM560,36H604A34,23 0 0 1 604,82H560Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706,100A100,103 0 1 1 906,100A100,103 0 1 1 706,100Z M748,100A58,66 0 1 0 864,100A58,66 0 1 0 748,100Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#58A8F7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170,147.59L170,200L125.59,200Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,0L256,0L256,35.29L216,82.49Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNizroWordmarkReversed);
export default __webpack_public_path__ + "static/media/nizro-wordmark-reversed.bc26022ca25d1ab6c3b4d7722089e071.svg";
export { ForwardRef as ReactComponent };